import * as React from "react";

function SvgRamen(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 518 125"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <g fill="#0FAA97">
        <path d="M76.4 86.2V125H48.6V86.8c0-5.8-4.6-10.4-10.4-10.4-5.9 0-10.5 4.6-10.5 10.4V125H0V0h38.8c20.9.4 37.6 17.2 37.6 38.2 0 9.1-3.2 17.6-8.8 24.2 5.4 6.6 8.7 14.8 8.8 23.8zM27.8 27.8v22.4c3.4-1 6.9-1.5 10.5-1.5 5.8 0 10.4-4.6 10.4-10.4S44 27.8 38.3 27.8H27.8zM174.6 48.6V125h-27.8V76.4h-12.4c-2.9-.1-5.8-.6-8.5-1.4v50H98.2V38.2C98.2 17.1 115.4 0 136.5 0c21 0 38.1 17.1 38.1 38.2v10.4zm-27.7 0V38.2c0-5.8-4.6-10.5-10.4-10.5-5.9 0-10.5 4.8-10.5 10.5s4.6 10.4 10.4 10.4h10.5zM321.5 122.5v2.5h-27.8V38.2c0-5.8-4.8-10.5-10.5-10.5s-10.4 4.8-10.4 10.5V125H245V38.2c0-5.8-4.6-10.5-10.4-10.5-5.9 0-10.5 4.8-10.5 10.5V125h-27.8V38.2c0-21.1 17.1-38.2 38.2-38.2 9.1 0 17.6 3.2 24.2 8.8 6.6-5.5 15.1-8.8 24.2-8.8 21.1 0 38.2 17.1 38.2 38.2v84.3zM371.1 50.1c3.4-1 6.9-1.5 10.5-1.5H410v27.8h-28.4c-5.9 0-10.5 4.6-10.5 10.4 0 5.9 4.6 10.5 10.5 10.5h38.1V125h-38.1c-21.1 0-38.2-17.1-38.2-38.2V38.2c0-21 16.8-37.9 37.6-38.2h38.8v27.8h-38.2c-5.8 0-10.4 4.8-10.4 10.5v11.8zM518 86.8V125h-27.7V38.2c0-5.8-4.6-10.5-10.4-10.5h-10.5V125h-27.8V0h38.8C501.2.4 518 17.2 518 38.2v48.6z" />
      </g>
    </svg>
  );
}

export default React.forwardRef(SvgRamen);
